import { createStore, createHook } from 'react-sweet-state';

import type { QueryResult } from './useExperimentalQuery';

export type QueryCache<TData> = {
	[key: string]: QueryResult<TData>;
};

const Store = createStore({
	initialState: {},
	actions: {
		setResult:
			<TData>(key: string, state: QueryResult<TData>) =>
			({ setState }) => {
				setState({
					[key]: state,
				});
			},
	},
	name: 'useExperimentalQueryResults',
});

export const useExperimentalQueryResults = createHook(Store) as <TData>() => [
	QueryCache<TData>,
	{ setResult: (key: string, state: QueryResult<TData>) => void },
];
